import React from "react";
import { Container, Typography, Paper, AppBar, Toolbar } from "@mui/material";
import { Box } from "@mui/system";

const PrivacyPolicy = () => {
  return (
    <>
      <AppBar position="static">
        <Toolbar>
          <Typography variant="h6">Privacy Policy</Typography>
        </Toolbar>
      </AppBar>
      <Container maxWidth="md" style={{ marginTop: 20 }}>
        <Box  style={{ padding: "40px 20px" }}>
          <Typography variant="h4" gutterBottom>
            Informativa sulla Privacy
          </Typography>
          <Typography variant="body1" paragraph>
            Ultimo aggiornamento: 01.03.2025
          </Typography>
          <Typography variant="body1" paragraph>
            La presente Informativa sulla Privacy descrive le modalità di
            raccolta, utilizzo e protezione dei dati personali degli utenti del
            sito web Partenope Immobiliare, in conformità al Regolamento UE
            2016/679 (GDPR).
          </Typography>
          <Typography variant="h6">1. Titolare del trattamento</Typography>
          <Typography variant="body1" paragraph>
            Il titolare del trattamento dei dati personali è: Partenope
            Immobiliare, Via Giuseppe Orsi 28, Napoli, partenopeimmobiliare@gmail.com
          </Typography>
          <Typography variant="h6">2. Tipologia di dati raccolti</Typography>
          <Typography variant="body1" paragraph>
            Durante la navigazione sul Sito, potremmo raccogliere le seguenti
            categorie di dati: - Dati di navigazione (indirizzo IP, tipo di
            browser, dati di accesso e navigazione). - Dati forniti
            volontariamente (nome, cognome, email, numero di telefono, ecc.). -
            Cookie e tecnologie di tracciamento (vedi nostra Cookie Policy).
          </Typography>
          <Typography variant="h6">3. Finalità del trattamento</Typography>
          <Typography variant="body1" paragraph>
            I dati raccolti vengono trattati per fornire e migliorare i servizi,
            rispondere alle richieste, adempiere ad obblighi legali e inviare
            comunicazioni di marketing previo consenso esplicito.
          </Typography>
          <Typography variant="h6">4. Diritti dell’utente</Typography>
          <Typography variant="body1" paragraph>
            L’utente ha diritto di accesso, rettifica, cancellazione,
            opposizione, limitazione e portabilità dei propri dati, oltre alla
            possibilità di revocare il consenso in qualsiasi momento.
          </Typography>
          <Typography variant="body1" paragraph>
            Per ulteriori informazioni, contattaci all’indirizzo email: partenopeimmobiliare@gmail.com.
          </Typography>
        </Box>
      </Container>
    </>
  );
};

export default PrivacyPolicy;
